import './index.css';
import {HashRouter as Router, Routes, Route, Navigate} from "react-router-dom";

import MyContextProvider from './components/login/MyContext';
import history from './components/login/history';

import Inicio from './components/views/inicio/Inicio';

import Principal from './components/views/principal/Principal';
import Anuncios from './components/views/anuncios/Anuncios';
import Sitios from './components/views/sitios/Sitios';
import Pagos from './components/views/pagos/Pagos';

function App() {
  return (
    <MyContextProvider>
      <Router>
      <Inicio/>
      <Routes>
      <Route path="/Principal" element = {<Principal/>}></Route>
      <Route path="/Anuncios" element = {<Anuncios/>}></Route>
      <Route path="/Sitios" element = {<Sitios/>}></Route>
      <Route path="/Pagos" element = {<Pagos/>}></Route>

      <Route history={history}></Route>
      <Route path="/" element={<Navigate replace to="/Principal" />}></Route>

      </Routes>
      </Router>
      </MyContextProvider>
  );
}

export default App;
